import { Checkbox, FormControlLabel } from "@mui/material";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { sprinklerTypes } from "../listing/constants";
import "./Industrial.css";

const IndustrialForm = (props) => {
    const { context, data, disableInputs, errors, listingStatus, onChange } = props;

    const handleAttributeUpdate = (event) => {
        onChange(event.target.id, event.target.value);
    };
    const flexContainerClass =
        context === "listing" ? "industrialFlexContainerListView" : "industrialFlexContainerPropertyView";
    return (
        <div>
            {context === "listing" && (
                <div>
                    <div className="industrialFlexContainer">
                        <div className="industrialFlexContainerUnresponsive">
                            <div className="industrialFlexField">
                                <BSInput
                                    id="industrialSf"
                                    label="INDUSTRIAL SF AVAILABLE"
                                    errorText="Must be a whole number"
                                    value={data.industrialSf}
                                    error={errors.industrialSf}
                                    onChange={handleAttributeUpdate}
                                    placeholder="Enter SF"
                                    disabled={disableInputs}
                                    integer
                                />
                            </div>
                            <div className="industrialFlexField">
                                <BSInput
                                    id="largestContigSf"
                                    label="INDUSTRIAL CONTIGUOUS SF AVAILABLE"
                                    errorText="ex. 98101"
                                    value={data.largestContigSf}
                                    error={errors.largestContigSf}
                                    onChange={handleAttributeUpdate}
                                    placeholder="Enter SF"
                                    disabled={disableInputs}
                                    integer
                                />
                            </div>
                        </div>
                        <div className="industrialFlexContainerUnresponsive">
                            <div className="industrialFlexField">
                                <BSInput
                                    id="officeSf"
                                    label="Office Space Sf"
                                    placeholder="Enter SF"
                                    errorText="Must be a whole number"
                                    error={errors.officeSf}
                                    value={data.officeSf}
                                    onChange={handleAttributeUpdate}
                                    disabled={disableInputs}
                                    integer
                                />
                            </div>
                            <div className="industrialFlexField">
                                <BSInput
                                    id="yardSf"
                                    label="INDUSTRIAL YARD SF"
                                    placeholder="Enter SF"
                                    errorText="Must be a whole number"
                                    error={errors.yardSf}
                                    value={data.yardSf}
                                    onChange={handleAttributeUpdate}
                                    disabled={disableInputs}
                                    integer
                                />
                            </div>
                        </div>
                    </div>

                    <div className="industrialFlexContainer">
                        <div className="industrialFlexContainerUnresponsive">
                            {listingStatus === "Appraisal" && (
                                <div className="industrialFlexField">
                                    <BSInput
                                        id="coldStorageSf"
                                        label="COLD STORAGE SF"
                                        placeholder="Enter SF"
                                        errorText="Must be a whole number"
                                        error={errors.coldStorageSf}
                                        value={data.coldStorageSf}
                                        onChange={handleAttributeUpdate}
                                        disabled={disableInputs}
                                    />
                                </div>
                            )}
                            <div className="industrialFlexField">
                                <BSInput
                                    id="officeBreakdownSfRate"
                                    label="OFFICE RATE"
                                    errorText="ex. 98.10"
                                    value={data.officeBreakdownSfRate}
                                    error={errors.officeBreakdownSfRate}
                                    onChange={handleAttributeUpdate}
                                    placeholder="$_._SF/MTH"
                                    disabled={disableInputs}
                                    numeric
                                />
                            </div>
                        </div>
                        <div className="industrialFlexContainerUnresponsive">
                            <div className="industrialFlexField">
                                <BSInput
                                    id="warehouseShellBreakdownRate"
                                    label="WAREHOUSE/SHELL RATE"
                                    errorText="ex. 98.10"
                                    value={data.warehouseShellBreakdownRate}
                                    error={errors.warehouseShellBreakdownRate}
                                    onChange={handleAttributeUpdate}
                                    placeholder="$_._SF/MTH"
                                    disabled={disableInputs}
                                    numeric
                                />
                            </div>
                            <div className="industrialFlexField">
                                <BSInput
                                    id="blendedRate"
                                    label="BLENDED ASKING RATE"
                                    errorText="ex. 98.10"
                                    value={data.blendedRate}
                                    error={errors.blendedRate}
                                    onChange={handleAttributeUpdate}
                                    placeholder="$_._SF/MTH"
                                    disabled={disableInputs}
                                    numeric
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className={flexContainerClass}>
                <div className="industrialFlexContainerUnresponsive">
                    <div className="industrialFlexField">
                        <BSInput
                            id="voltsNum"
                            label="VOLTS"
                            placeholder="Enter volts"
                            error={errors.voltsNum}
                            value={data.voltsNum}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div className="industrialFlexField">
                        <BSInput
                            id="ampsNum"
                            label="AMPS"
                            placeholder="Enter amps"
                            error={errors.ampsNum}
                            errorText="Numeric only (ex. 98101)"
                            value={data.ampsNum}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div className="industrialFlexField">
                        <BSInput
                            id="phaseNum"
                            label="PHASE"
                            error={errors.phaseNum}
                            value={data.phaseNum}
                            onChange={handleAttributeUpdate}
                            placeholder="Enter phase"
                            disabled={disableInputs}
                        />
                    </div>
                </div>
                <div className="industrialFlexContainerUnresponsive">
                    <div className="industrialFlexField">
                        <BSInput
                            id="gradeLevelDoorsNum"
                            label="DOORS AT GRADE"
                            placeholder="Enter doors at grade"
                            errorText="Must be a whole number"
                            error={errors.gradeLevelDoorsNum}
                            value={data.gradeLevelDoorsNum}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div className="industrialFlexField">
                        <BSInput
                            id="dockHighDoorsNum"
                            label="DOORS DOCK HIGH"
                            placeholder="Enter doors dock high"
                            errorText="Must be a whole number"
                            error={errors.dockHighDoorsNum}
                            value={data.dockHighDoorsNum}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                </div>
            </div>

            <div className={flexContainerClass}>
                <div className="industrialFlexContainerUnresponsive">
                    <div className="industrialFlexField">
                        <BSInput
                            id="railDoorsNum"
                            label="RAIL DOORS"
                            placeholder="Enter # of rail doors"
                            errorText="Must be a whole number"
                            error={errors.railDoorsNum}
                            value={data.railDoorsNum}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div className="industrialFlexField">
                        <BSInput
                            id="clearHeightMin"
                            label="CLEAR HEIGHT MIN"
                            placeholder="Enter min clear height in ft"
                            errorText="Must be a whole number"
                            error={errors.clearHeightMin}
                            value={data.clearHeightMin}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div className="industrialFlexField">
                        <BSInput
                            id="clearHeightMax"
                            label="CLEAR HEIGHT MAX"
                            placeholder="Enter max clear height in ft"
                            errorText="Must be a whole number"
                            error={errors.clearHeightMax}
                            value={data.clearHeightMax}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                </div>
                <div className="industrialFlexContainerUnresponsive industrialAlignCenter">
                    <div className="industrialFlexField">
                        <BSInput
                            id="cranesQty"
                            label="CRANE COUNT"
                            placeholder="Enter crane count"
                            errorText="Must be a whole number"
                            error={errors.cranesQty}
                            value={data.cranesQty}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    </div>
                    <div className="industrialFlexField">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.cranesBldgFlg ? true : false}
                                    onChange={(e, checked) => onChange(e.target.value, checked)}
                                    value="cranesBldgFlg"
                                    disabled={disableInputs === true}
                                    color="primary"
                                />
                            }
                            label="Crane Served"
                            style={{ marginLeft: "5px" }}
                        />
                    </div>
                </div>
            </div>

            <div className={flexContainerClass}>
                <div className="industrialFlexField">
                    <BSInput
                        id="craneNotes"
                        label="CRANE NOTES"
                        placeholder="Enter crane notes"
                        error={errors.craneNotes}
                        value={data.craneNotes}
                        onChange={handleAttributeUpdate}
                        disabled={disableInputs}
                    />
                </div>
            </div>
            <div className="industrialFlexContainer">
                <div className="industrialFlexField">
                    <BSInput
                        id="yardNotes"
                        label="INDUSTRIAL YARD NOTES"
                        placeholder="Enter notes"
                        error={errors.yardNotes}
                        value={data.yardNotes}
                        onChange={handleAttributeUpdate}
                        disabled={disableInputs}
                    />
                </div>
            </div>
            {listingStatus === "Appraisal" ? (
                <div className="industrialCheckboxContainer">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.coldStorageFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="coldStorageFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Cold Storage"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.dataCenterFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="dataCenterFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Data Center"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.distributionFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="distributionFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Distribution"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.electricStandardBldg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="electricStandardBldg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Electric Standard"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.electricHeavyBldgFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="electricHeavyBldgFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Electric Heavy"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.fencedFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="fencedFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Fenced"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.acFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="acFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="HVAC"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.labSpaceFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="labSpaceFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Lab Space"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.manufacturingFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="manufacturingFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Manufacturing"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.pavedFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="pavedFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Paved"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.flexFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="flexFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Flex"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.railServiceFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="railServiceFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Rail Served"
                    />
                </div>
            ) : (
                <div className="industrialCheckboxContainer">
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.electricStandardBldg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="electricStandardBldg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Electric Standard"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.electricHeavyBldgFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="electricHeavyBldgFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Electric Heavy"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.fencedFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="fencedFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Fenced"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.acFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="acFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="HVAC"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.labSpaceFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="labSpaceFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Lab Space"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.pavedFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="pavedFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Paved"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={data.railServiceFlg ? true : false}
                                onChange={(e, checked) => onChange(e.target.value, checked)}
                                value="railServiceFlg"
                                disabled={disableInputs === true}
                                color="primary"
                            />
                        }
                        label="Rail Served"
                    />
                </div>
            )}

            <div className="industrialSprinklers">
                <BSSelect
                    id="sprinklers"
                    label="Sprinklers"
                    value={data.sprinklers}
                    error={errors.sprinklers}
                    onChange={handleAttributeUpdate}
                    options={sprinklerTypes}
                    disabled={disableInputs === true}
                />
            </div>
        </div>
    );
};

export default IndustrialForm;
